import React from 'react'
import styled from 'styled-components'

const ContainerStyles = styled.div`
  margin: 1rem auto 12rem auto;
  max-width: 720px;
  text-align: justify;
  text-justify: inter-word;

  @media (max-width: 800px) {
    width: 90%;
    text-align: left;
	}
`

const Container = ({children}) => (
  <ContainerStyles>
    {children}
  </ContainerStyles>
)

export default Container


// WEBPACK FOOTER //
// ./src/components/container.js